import { render, staticRenderFns } from "./RequestInvitation.vue?vue&type=template&id=dceb4bdc&"
import script from "./RequestInvitation.vue?vue&type=script&lang=js&"
export * from "./RequestInvitation.vue?vue&type=script&lang=js&"
import style0 from "./RequestInvitation.vue?vue&type=style&index=0&id=dceb4bdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports